import { render, staticRenderFns } from "./TcpaHistoryTable.vue?vue&type=template&id=0279f575"
import script from "./TcpaHistoryTable.vue?vue&type=script&lang=js"
export * from "./TcpaHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports